import { FeedbackPromptResponseDetails } from "./EmployeeFeedbackModel";

export class NewJoinerDOJModel {
    EnterpriseId !: string;
    CardUniqueId!: string;
    CategoryType!: string;
    ChannelType!: string;
    FeedbackPromptResponseDetails !: FeedbackPromptResponseDetails[];
    IsPostAnonymous !: boolean;
}